<script>
import axios from "axios";
import appConfig from "@/app.config";
export default {
  page: {
    title: "Login ",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      username: "",
      password: "",
      error:'',
      loader:false,
      showPassword:false,
    };
  },
  methods: {
    async login() { 
      this.loader=true;
      let formData = new FormData();
      formData.append("username", this.username);
      formData.append("password", this.password);
      let url = "/login";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          let userData=response.data.user;
          let token=response.data.token;
          let license=response.data.license;
          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          localStorage.setItem('user', JSON.stringify(userData))
          localStorage.setItem('token',token);
          localStorage.setItem('license',license);
          this.$router.push(this.$route.query.redirectFrom || {name: "default",})
        } else {
          this.error=response.data.message;
          this.loader=false;
        }
      })
      },
      togglePasswordVisibilty() {
      this.showPassword = !this.showPassword;
    },
  },
  mounted() {
    document.body.classList.add("auth-body-bg");
  },
  computed: {
    inputType() {
      return this.showPassword ? "text" : "password";
    },
  },
};
</script>

<template>

  <div>
    <div class="container-fluid p-0">
      <div class="row g-0">
        <div class="col-xl-8 d-none d-sm-block shadow-lg">
          <img src="@/assets/images/banner.jpg" alt class="img-fluid d-flex h-100 flex-column" />
        </div>

        <div class="col-xl-4">
          <div class="auth-full-page-content p-md-5 p-4">
            <div class="w-100">
              <div class="d-flex flex-column h-100">
                <div class="my-auto">
                  <div class="d-flex flex-row">
                    <span class="mt-3"><br><img src="@/assets/images/logo.png" height="65px"/></span>
                    <span class="mt-5"><h5 class="text-primary">Welcome Back !</h5>
                    <p class="text-muted">Daherz Family Doctors.</p></span>
                  </div>
                  <div v-if="error" class="bg-danger text-white p-2 mt-3" style="font-size:12px">{{ error }}</div >
                  <div class="mt-2">
                    <b-form class="p-2" @submit.prevent="login">
                      <b-form-group class="mb-3" id="input-group-1" label="Username" label-for="input-1" >
                        <b-form-input id="input-1" v-model="username" required="" type="text" placeholder="Enter Username"></b-form-input>
                      </b-form-group>
                      <b-form-group class="mb-3" id="input-group-2" label="Password" label-for="input-2">
                        <div class="d-flex">
                          <b-form-input id="input-2" v-model="password" required="" :type="inputType"
                            placeholder="Enter password"></b-form-input>
                          <div class="input-group-append">
                            <button class="btn btn-outline-primary" type="button" @click="togglePasswordVisibilty">
                              <span :style="{
                                'font-size': showPassword ? '15px' : '15px',
                              }" :class="[
                                'mdi',
                                {
                                  'mdi-eye-off': !showPassword,
                                  'mdi-eye': showPassword,
                                },
                                'toggle-password',
                              ]"></span>
                            </button>
                          </div>
                        </div>
                      </b-form-group>

                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="remember-check"/>
                        <label class="form-check-label" for="remember-check">Remember me</label>
                      </div>

                      <div class="mt-3 d-grid">
                      <b-button type="submit" variant="primary">Log In <b-spinner v-if="loader" small class="mr-1" label="Small Spinner"/></b-button>
                      </div>
                    
                    </b-form>
                    <div class="mt-5 text-center">
                        Visit our Website <a href="https://daherzfamilydoctors.com/" target="_blank" class="fw-medium text-primary">Daherz Family Doctors</a>
                    </div>
                  </div>
                </div>

                
              </div>
            </div>
          </div>
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
    <!-- end container-fluid -->
  </div>
</template>

<style lang="scss" scoped>
::v-deep .carousel-caption {
  position: relative !important;
  right: 0;
  bottom: 1.25rem;
  left: 0;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #495057;
  text-align: center;
}

::v-deep .carousel-indicators li {
  background-color: rgba(85, 110, 230, 0.25);
}
</style>